import { buildGanttCalendar } from "../../../../engine/core/gantt-calendar.js";
import { calendarDay } from "../../../../engine/core/calendar-day.js";

export function buildGanttModel(entries, dayWidth = 28, rowHeightOverride, options = {}) {
  const labelWidth = 132;
  const axisHeight = 44;
  const rowHeight = Math.max(18, Math.min(120, rowHeightOverride || 44));
  const todayDay = calendarDay(new Date());
  const minDay = entries.reduce((value, entry) => Math.min(value, entry.startDay), todayDay);
  const maxDay = entries.reduce((value, entry) => Math.max(value, entry.endDay), todayDay);
  const padding = Math.max(7, Math.ceil(2 * (options.viewportWidth || 360) / dayWidth));
  const startDay = Math.min(minDay - padding, options.bounds?.startDay ?? Infinity);
  const endDay = Math.max(maxDay + padding, options.bounds?.endDay ?? -Infinity);
  const totalDays = endDay - startDay + 1;
  const width = Math.max(360, labelWidth + totalDays * dayWidth + 24);
  const height = Math.max(options.minHeight || 240, axisHeight + entries.length * rowHeight + 12);
  const ticks = buildGanttTicks(startDay, endDay, dayWidth, labelWidth);

  const rows = entries.map((entry) => {
    const span = entry.endDay - entry.startDay + 1;
    return {
      ...entry,
      x: labelWidth + (entry.startDay - startDay) * dayWidth + Math.min(3, dayWidth / 4),
      width: Math.max(2, span * dayWidth - Math.min(6, dayWidth / 2)),
    };
  });

  return { rows, ticks, labelWidth, dayWidth, axisHeight, rowHeight, startDay, endDay, width, height };
}

export function buildGanttTicks(startDay, endDay, dayWidth, labelWidth) {
  const { levels, lines } = buildGanttCalendar(startDay, endDay + 1, dayWidth);
  const finest = levels.at(-1)?.unit;
  return lines.map(line => {
    const label = ['year', 'quarter', 'month'].includes(line.unit) && line.width >= (line.unit === 'year' ? 26 : 30) ? line.label : '';
    const sub = finest === 'day' && dayWidth >= 20 ? String(new Date(line.day * 86400000).getUTCDate())
      : finest === 'week' && line.unit === 'week' ? line.label : '';
    return { ...line, x: labelWidth + line.x, label, sub };
  });
}
